import { render } from "./UnitTestExecution.vue?vue&type=template&id=2b689794"
import script from "./UnitTestExecution.vue?vue&type=script&lang=js"
export * from "./UnitTestExecution.vue?vue&type=script&lang=js"

import "./UnitTestExecution.vue?vue&type=style&index=0&id=2b689794&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__